export enum FinancingIntegrationTypeEnum {
  LEANPAY = 'leanpay_leasing',
  NLB_LEASING = 'nlb_leasing',
  NLB_UX = 'nlb_ux_leasing',
  ADDIKO = 'addiko',
}
